import { DefaultTitle } from "./style";


interface IProps {
    title?: string;
    marginTop?: any;

}

const StyledTitle = ({
    title = 'title',
    marginTop = 4.5,

}: IProps) => (
    <DefaultTitle top={marginTop}>
        {title}
    </DefaultTitle>
);


export { StyledTitle }